import type { IconData } from '@stacksjs/iconify-core'

export const dz1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M256 0h256v512H256z\"/><path fill=\"#006233\" d=\"M0 0h256v512H0z\"/><path fill=\"#d21034\" d=\"M367 192a128 128 0 1 0 0 128a102.4 102.4 0 1 1 0-128m4.2 64L256 218.4l71.7 98.2V195.4L256 293.6z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default dz1x1
